import { sazkaAlert } from "@sazka/utils/sazka-alert";

/* eslint-disable @typescript-eslint/naming-convention */
const onlineErrors = {
    GENERAL: { title: "Něco se pokazilo", text: "Omlouváme se, došlo k neočekávané chybě." },
    PRICE_TOO_HIGH: {
        title: "Něco se pokazilo",
        text: "Sázka nebyla umožněna z důvodu překročení maximální možné výhry.",
    },
    DRAW_BREAK: {
        title: "Technická přestávka",
        text: "Omlouváme se, právě probíhá technická přestávka. Děkujeme za pochopení.",
    },
    MIDNIGHT_GAME_BREAK: {
        title: "Technická přestávka",
        text: "Omlouváme se, do 00:03 probíhá pravidelná technická přestávka. Děkujeme za pochopení.",
    },
    INSUFFICIENT_FUNDS: {
        title: "Něco se pokazilo",
        text: "Vypadá to, že na účtu nemáte dostatek financí. Zkontrolujte prosím stav svého účtu a obnovte stránku.",
    },
    NOT_AUTORIZED: {
        title: "Něco se pokazilo",
        text: "Vypadá to, že je problém s vaším přihlášením, zkuste prosím obnovit stránku.",
    },
    RESPONSIBLE_GAMING: {
        title: "Překročili jste limit zodpovědného hraní",
        text: "Váš limit zodpovědného hraní neumožňuje vsadit tuto sázku.",
        btnText: "Upravit sázku",
        link: "/zodpovedne-hrani/herni-limity",
        linkText: "Zodpovědné hraní",
    },
    PAYMENT_BRANDS_PLAY_LIMITS_ISSUE: {
        title: "Tuto sázku bohužel nelze vsadit",
        text: "Překročili jste limit zodpovědného hraní:<br/>Celková výše sázky</strong>",
        btnText: "Upravit sázku",
        link: "/zodpovedne-hrani/herni-limity",
        linkText: "Zodpovědné hraní",
    },
    PAYMENT_RESPONSIBLE_GAMING_PLAY_LIMITS_ISSUE: {
        title: "Tuto sázku bohužel nelze vsadit",
        text: "Překročili jste limit zodpovědného hraní:<br/><strong>Výše sázek za dané období</strong>",
        btnText: "Upravit sázku",
        link: "/zodpovedne-hrani/herni-limity",
        linkText: "Zodpovědné hraní",
    },
    PAYMENT_RESPONSIBLE_GAMING_DAILY_LOSS_LIMITS_ISSUE: {
        title: "Tuto sázku bohužel nelze vsadit",
        text: "Překročili jste limit zodpovědného hraní:<br/><strong>Čistá prohra za den</strong>",
        btnText: "Upravit sázku",
        link: "/zodpovedne-hrani/herni-limity",
        linkText: "Zodpovědné hraní",
    },
    PAYMENT_RESPONSIBLE_GAMING_MONTHLY_LOSS_LIMITS_ISSUE: {
        title: "Tuto sázku bohužel nelze vsadit",
        text: "Překročili jste limit zodpovědného hraní:<br/><strong>Čistá prohra za měsíc</strong>",
        btnText: "Upravit sázku",
        link: "/zodpovedne-hrani/herni-limity",
        linkText: "Zodpovědné hraní",
    },
    PAYMENT_BRANDS_DAILY_LOSS_LIMITS_ISSUE: {
        title: "Tuto sázku bohužel nelze vsadit",
        text: "Překročili jste limit zodpovědného hraní:<br/><strong>Výše sázek za den</strong>",
        btnText: "Upravit sázku",
        link: "/zodpovedne-hrani/herni-limity",
        linkText: "Zodpovědné hraní",
    },
    PAYMENT_BRANDS_MONTHLY_LOSS_LIMITS_ISSUE: {
        title: "Tuto sázku bohužel nelze vsadit",
        text: "Překročili jste limit zodpovědného hraní:<br/><strong>Výše sázek za měsíc</strong>",
        btnText: "Upravit sázku",
        link: "/zodpovedne-hrani/herni-limity",
        linkText: "Zodpovědné hraní",
    },
    PAYMENT_COOL_OFF_PERIOD_ISSUE: {
        title: "Tuto sázku bohužel nelze vsadit",
        text: "Překročili jste limit zodpovědného hraní:<br/><strong>Pauza po odhlášení</strong>",
        btnText: "Upravit sázku",
        link: "/zodpovedne-hrani/herni-limity",
        linkText: "Zodpovědné hraní",
    },
    PLAYER_SSO_CONNECTION_ERROR: {
        title: "Něco se pokazilo",
        text: "Omlouváme se, ale zřejmě vypršelo vaše přihlášení. Prosím zkuste obnovit stránku a znovu se přihlásit.",
    },
    INTERNAL_SERVER_ERROR: {
        title: "Něco se pokazilo",
        text: "Omlouváme se, ale došlo k přetížení systému. Před další akcí si zkontrolujte seznam uzavřených sázek v sekci Moje sázky.",
    },
    PAYMENT_CONNECTION_ERROR: { title: "Něco se pokazilo", text: "Nastal problém s připojením k platební bráně." },
    SUBSCRIPTION_ERROR: { title: "Něco se pokazilo", text: "Nesprávné předplatné." },
    WAGER_CANCEL_ERROR: {
        title: "Něco se pokazilo",
        text: "Problém se zrušením tiketu. Tiket je už zrušený, nebo jeho zrušení není možné.",
    },
    EXTERNAL_SYSTEM_ERROR: { title: "Něco se pokazilo", text: "Problém s připojením k externímu systému." },
    VALIDATION_ERROR: {
        title: "Něco se pokazilo",
        text: "Problém s validací tiketu. Pravděpodobně byly vyplněné nesprávné hodnoty.",
    },
    NOT_ENOUGH_FUTURE_DRAWS: {
        title: "Něco se pokazilo",
        text: "Vážení zákazníci, připravujeme nové pravidelné slosování. Z technických důvodů dočasně zkracujeme délku předplatného. Vyberte kratší předplatné.",
    },
    CSRF: {
        title: "Něco se pokazilo",
        text: "Nastal problém s ověřením požadavku. Zkuste prosím obnovit stránku a provést akci znovu.",
    },
    FORBIDDEN_WORDS_ERROR: {
        title: "Název nevyhovuje pravidlům pro pojmenování sázenek. Zkuste vymyslet jiný.",
    },
    SYNDICATES_SUPPRESSED: {
        title: "Technická přestávka",
        text: "Litujeme, v době od <strong>0:00</strong> do <strong>1:15</strong> probíhá technická údržba systému a není možné vsadit <strong>skupinové sázky</strong>.",
    },
    CREATE_TIME_EXPIRED: {
        title: "Čas pro vytvoření vypršel",
        text: "Sázenky se uzavírají 15 minut před slosováním",
    },
    JOIN_TIME_EXPIRED: {
        title: "Čas pro připojení vypršel",
        text: "Připájení k sázence se uzavírá 5 minut před slosováním",
    },
    MAXIMUM_NUMBER_OF_SYNDICATES_REACHED: {
        title: "Je nám líto",
        text: "<strong>V systému nyní máme maximální počet otevřených skupinových sázenek.</strong><br/>Pokud chcete vytvořit novou sázenku, zkuste to později.",
    },
    MAXIMUM_NUMBER_OF_FRACTIONS_EXCEEDED: {
        title: "Je nám líto",
        text: "Ve skupinové sázence není k dispozici požadovaný počet podílů. Prosím, upravte počet podílů, které chcete zakoupit.",
    },
    CLOSED_FOR_JOIN: {
        title: "Je nám líto",
        text: "K této skupinové sázence není možné se připojit.",
    },
    INVALID_CHARACTERS_IN_SYNDICATE_NAME: {
        title: "Chyba",
        text: "Název sázenky obsahuje nepovolené znaky jako např. tečka, čárka, uvozovky.<br/>Prosíme, upravte název.",
    },
    LIMIT_EXCEEDED: {
        title: "Tuto sázku bohužel nelze vsadit",
        text: "Překročen limit maximální sázky.",
    },
};

export const sazkaAlertOnline = (errorKey: string, myTicketsSection = false) => {
    if (myTicketsSection && errorKey === "INTERNAL_SERVER_ERROR") {
        // return sazkaAlert("Něco se pokazilo", "Omlouváme se, došlo k chybě systému.");
        errorKey = "GENERAL";
    }

    if (typeof errorKey !== "string") errorKey = "GENERAL";
    let key = errorKey.toUpperCase() || "GENERAL";
    if (!onlineErrors[key]) {
        key = "GENERAL";
    }
    const error = onlineErrors[key];
    return sazkaAlert(error.title, error.text, error.linkText, error.link, error.buttonText);
};
